/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagebuyerstitle3Inputs */

const en_ticketpagebuyerstitle3 = /** @type {(inputs: Ticketpagebuyerstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers`)
};

const de_ticketpagebuyerstitle3 = /** @type {(inputs: Ticketpagebuyerstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer`)
};

/**
* | output |
* | --- |
* | "Buyers" |
*
* @param {Ticketpagebuyerstitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagebuyerstitle3 = /** @type {((inputs?: Ticketpagebuyerstitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagebuyerstitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagebuyerstitle3(inputs)
	return de_ticketpagebuyerstitle3(inputs)
});
export { ticketpagebuyerstitle3 as "ticketPageBuyersTitle" }